import { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@fortawesome/free-regular-svg-icons';
import {
  faUser,
  faPlus,
  faUserGroup,
  faSearch,
  faArrowRight,
  faArrowLeft,
  faChartPie,
  faPenToSquare,
} from '@fortawesome/free-solid-svg-icons';

import styled from 'styled-components';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  getTournamentList,
  deleteTournament,
  bulkDeleteTournaments,
  getTournamentCreators,
} from '../../../modules/tournament_api';
import { tournamentDialogDisplay } from './tournament-field-mapper';
import Dialog from '../../../ui_refresh/components/Dialog';
import TournamentDialog from '../../../ui_refresh/components/TournamentDialog';
import TournamentFilters from '../../../ui_refresh/components/TournamentFilters';
import moment from 'moment';
import { toast } from 'react-toastify';
import { headerOverlayToggle } from '../../../ui_refresh/utils/headerOverlayToggle';

const DeleteButton = styled.button`
  color: white;
  background: red;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  padding: 5px 10px;
  transition: 0.2s;
  position: absolute;
  right: 0;
  top: -5px;
  &:hover {
    background: #ee6767;
  }
`;

class TournamentCreator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      navigate: '',
      searchString: '',
      previewTournamentData: '',
      fromDate: undefined,
      toDate: undefined,
      createdBy: undefined,
      creators: [],
      tournamentDialogVisible: false,
    };
  }

  componentDidMount() {
    const { searchString } = this.props;

    this.setState({ ...this.state, searchString });
    this.getTournamentCreators();
    this.getTournamentsList();
  }

  getTournamentCreators() {
    const { dispatch } = this.props;

    dispatch(getTournamentCreators());
  }

  getTournamentsList() {
    const { searchString, fromDate, toDate, createdBy } = this.state;
    const { dispatch, offset, limit } = this.props;

    dispatch(getTournamentList(offset, limit, searchString, fromDate, toDate, createdBy));
  }

  formatDates(tournaments) {
    const _tournaments = [];

    for (const tournament of tournaments) {
      const t = { ...tournament, startDate: new Date(tournament.startDate), endDate: new Date(tournament.endDate) };

      _tournaments.push(t);
    }

    return _tournaments;
  }

  submitSearch(event) {
    event.preventDefault();

    const { searchString } = this.state;
    const { dispatch, limit } = this.props;

    dispatch(getTournamentList(0, limit, searchString));
  }

  async handleBulkDelete() {
    const { tournaments, userID } = this.props;

    const deletableTournamentIds = [];

    tournaments.map((tournament) => {
      if (tournament.canDelete) {
        if (tournament.creatorID && tournament.creatorID === userID) {
          deletableTournamentIds.push(tournament.tournamentId);
        }
      }
    });

    if (deletableTournamentIds.length === 0) {
      alert("Cannot delete 'Active' or 'Completed' tournaments... No 'Scheduled' tournaments match your filter.");
      return;
    }

    if (window.confirm(`You are about to delete ${deletableTournamentIds.length} tournaments, continue?`)) {
      try {
        await bulkDeleteTournaments(deletableTournamentIds);
        this.getTournamentsList();
      } catch (e) {
        alert('Something went wrong...');
        console.error(e);
      }
    }
  }

  async handleDelete(tournamentId) {
    const { tournaments } = this.props;
    const tournament = tournaments.filter((t) => t.tournamentId === tournamentId)[0];

    if (
      window.confirm(
        `You are deleting ${tournament.businessGroupName}:${tournament.gameName} tournament starting on ${moment(
          tournament.startDate
        ).format('LLL')}. Proceed?`
      )
    ) {
      try {
        await deleteTournament(tournamentId);

        toast.success(
          `DELETED: ${tournament.gameName} tournament on ${moment(tournament.startDate).format('LLL')} at ${
            tournament.businessGroupName
          }.`,
          { position: toast.POSITION.TOP_CENTER }
        );

        this.getTournamentsList();
      } catch (e) {
        console.error(e);
      }
    }
  }

  handlePreview(tournamentId) {
    const { tournaments } = this.props;
    const tournament = tournaments.filter((t) => t.tournamentId === tournamentId)[0];
    headerOverlayToggle('off');
    this.setState({
      ...this.state,
      tournamentDialogVisible: true,
      previewTournamentData: tournamentDialogDisplay(tournament),
    });
  }

  changePage(pageNum) {
    const { searchString } = this.state;
    const { dispatch, limit } = this.props;

    dispatch(getTournamentList(pageNum, limit, searchString));
  }

  filterCallback = (filters) => {
    const { dispatch, limit } = this.props;
    const { searchString } = this.state;
    const { createdBy, fromDate, toDate } = filters;

    const filterData = {
      createdBy: createdBy !== '-1' ? createdBy : undefined,
      fromDate: fromDate ? moment(fromDate).format('MM/DD/YYYY') : undefined,
      toDate: toDate ? moment(toDate).format('MM/DD/YYYY') : undefined,
    };

    this.setState({ ...this.state, ...filterData });
    dispatch(getTournamentList(0, limit, searchString, filterData.fromDate, filterData.toDate, filterData.createdBy));
  };

  closeDialog = () => {
    this.setState({ ...this.state, tournamentDialogVisible: false });
    headerOverlayToggle('on');
  };

  render() {
    const { navigate, searchString, previewTournamentData, tournamentDialogVisible } = this.state;
    const { tournaments, totalNumOfTournaments, offset, limit, tournamentCreators } = this.props;

    if (navigate !== '') {
      return <Redirect push to={navigate} />;
    }

    const _tournaments = this.formatDates(tournaments);
    const numOfPages = Math.ceil(totalNumOfTournaments / limit);

    return (
      <div className="tw-mx-10 tw-my-5">
        <div className="tw-w-full tw-h-16 tw-text-left tw-relative">
          <h1 className="tw-font-extrabold tw-text-2xl">I'm a Tournament creator watch me roar.</h1>
          <DeleteButton
            onClick={() => {
              this.handleBulkDelete();
            }}
          >
            Bulk Delete <i className="fa fa-trash"></i>
          </DeleteButton>
        </div>
        <div className="tw-w-full tw-h-10 tw-flex tw-items-left tw-relative">
          <button className="tw-btn tw-btn-primary" onClick={() => this.setState({ navigate: '/tournament/new' })}>
            <span>Create</span>
            <FontAwesomeIcon icon={faPlus} className="tw-h-6 tw-w-6" />
          </button>

          <form className="tw-w-full tw-max-w-sm tw-mx-5" onSubmit={(e) => this.submitSearch(e, searchString)}>
            <div className="tw-relative tw-flex tw-w-full tw-flex-wrap tw-items-stretch tw-mb-3">
              <label htmlFor="tournamentSearch" className="sr-only">
                Search
              </label>

              <input
                type="text"
                id="tournamentSearch"
                placeholder="Search by business group, game, title, etc..."
                className="tw-search-input"
                value={searchString}
                onChange={(e) => this.setState({ ...this.state, searchString: e.target.value })}
              />

              <span className="tw-z-10 tw-h-full tw-leading-snug tw-font-normal tw-absolute tw-text-center tw-text-blueGray-300 tw-absolute tw-bg-transparent tw-rounded tw-text-base tw-items-center tw-justify-center tw-w-8 tw-right-0 tw-pr-3 tw-py-2">
                <FontAwesomeIcon
                  icon={faSearch}
                  className="tw-h-6 tw-w-6 tw-cursor-pointer"
                  onClick={(e) => this.submitSearch(e, searchString)}
                />
              </span>
            </div>
          </form>
          <TournamentFilters creators={tournamentCreators} filterCallback={this.filterCallback} />
        </div>

        <div className="tw--mx-4 sm:tw--mx-8 tw-px-4 sm:tw-px-8 tw-py-4 tw-overflow-x-auto">
          <div className="tw-inline-block tw-min-w-full tw-shadow tw-rounded-lg tw-overflow-hidden">
            <table className="tw-min-w-full tw-leading-normal">
              <thead>
                <tr>
                  <th className="tw-th">Business Group</th>
                  <th className="tw-th">Game</th>
                  <th className="tw-th">Title</th>
                  <th className="tw-th">Date Start</th>
                  <th className="tw-th">Date End</th>
                  <th className="tw-th">Created By</th>
                  <th className="tw-th">Status</th>
                  <th className="tw-th">Action</th>
                </tr>
              </thead>

              <tbody>
                {_tournaments.map((tournament) => (
                  <tr key={tournament.tournamentId}>
                    <td className="tw-td">
                      <p className="tw-text-gray-900 tw-whitespace-no-wrap">{tournament.businessGroupName}</p>
                    </td>

                    <td className="tw-td">
                      <div className="tw-inline-flex">
                        {tournament.gameType === 'SinglePlayer' && (
                          <FontAwesomeIcon icon={faUser} className="tw-h-6 tw-w-6" />
                        )}
                        {tournament.gameType === 'MultiPlayer' && (
                          <FontAwesomeIcon icon={faUserGroup} className="tw-h-6 tw-w-6" />
                        )}
                        &nbsp;&nbsp;
                        <p className="tw-text-gray-900 tw-whitespace-no-wrap">{tournament.gameName}</p>
                      </div>
                    </td>

                    <td className="tw-td">
                      <p className="tw-text-gray-900 tw-whitespace-no-wrap">{tournament.tournamentName}</p>
                    </td>

                    <td className="tw-td">
                      <p className="tw-text-gray-900 tw-whitespace-no-wrap">
                        {moment(tournament.startDate).format('LLL')}
                      </p>
                    </td>

                    <td className="tw-td">
                      <p className="tw-text-gray-900 tw-whitespace-no-wrap">
                        {moment(tournament.endDate).format('LLL')}
                      </p>
                    </td>

                    <td className="tw-td">
                      <p className="tw-text-gray-900 tw-whitespace-no-wrap">
                        {tournament.creatorFirstName} {tournament.creatorLastName}
                      </p>
                    </td>

                    <td className="tw-td">
                      <p className="tw-text-gray-900 tw-whitespace-no-wrap">{tournament.tournamentStatus}</p>
                    </td>

                    <td className="tw-td">
                      <div className="tw-inline-flex">
                        <FontAwesomeIcon
                          icon={faPenToSquare}
                          className="tw-h-6 tw-w-6 tw-cursor-pointer"
                          onClick={() => this.setState({ navigate: `/tournament/${tournament.tournamentId}` })}
                        />
                        &nbsp;&nbsp;
                        {tournament.canDelete && (
                          <FontAwesomeIcon
                            icon={faTrashCan}
                            className="tw-h-6 tw-w-6 tw-cursor-pointer"
                            onClick={() => this.handleDelete(tournament.tournamentId)}
                          />
                        )}
                        {tournament.hasStats && (
                          <FontAwesomeIcon
                            icon={faChartPie}
                            className="tw-h-6 tw-w-6 tw-cursor-pointer"
                            onClick={() => this.handlePreview(tournament.tournamentId)}
                          />
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div>
            <button
              className="tw-btn tw-btn-secondary"
              disabled={offset <= 0}
              onClick={() => {
                this.changePage(offset - 1);
              }}
            >
              <FontAwesomeIcon icon={faArrowLeft} className="tw-h-6 tw-w-6 tw-cursor-pointer" />
            </button>
            &nbsp;&nbsp;&nbsp;
            <label htmlFor="">
              {' '}
              {offset + 1}&nbsp;/&nbsp;{numOfPages}
            </label>
            &nbsp;&nbsp;&nbsp;
            <button
              className="tw-btn tw-btn-secondary"
              disabled={offset >= numOfPages - 1}
              onClick={() => {
                this.changePage(offset + 1);
              }}
            >
              <FontAwesomeIcon icon={faArrowRight} className="tw-h-6 tw-w-6 tw-cursor-pointer" />
            </button>
          </div>

          <Dialog overflow isOpen={tournamentDialogVisible} closeCallback={() => this.closeDialog()}>
            <TournamentDialog tournament={previewTournamentData} />
          </Dialog>
        </div>
      </div>
    );
  }
}

const withState = connect((state) => {
  const { tournament, user } = state;
  return { ...tournament, searchString: '', userID: user.currentUserId };
});

export default withState(TournamentCreator);
